// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recognized-by__wrapper .recognized-by__second-carousel[data-v-6ca3d896]{margin-top:79px}@media (max-width:1199px){.recognized-by__wrapper .recognized-by__second-carousel[data-v-6ca3d896]{margin-top:60px}}@media (max-width:767px){.recognized-by__wrapper .recognized-by__second-carousel[data-v-6ca3d896]{margin-top:22px}}", ""]);
// Exports
module.exports = exports;
